import { useContext, useState } from "react"
import { Button, IconGoogle } from "../../../components/atoms"
import {
  FlatpickerHourGroup,
  InputGroup,
  SelectGroup
} from "../../../components/molecules"
import { Pagination } from "../../../components/organisms"
import {
  RowContract,
  TableReservas
} from "../../../components/organisms/TableReservas"
import { AuthContext } from "../../../contexts/Auth/AuthContext"
import { api, convertDateTimeToPattern as dateFormat } from "../../../helpers"

export function ReservasEfetuadas() {
  const { applicationData } = useContext(AuthContext)
  const [paginationControl, setPaginationControl] = useState<PaginationType>({
    offset: 0,
    limit: 10,
    count: 0
  })

  const [ReservasEfetuadas, setReservasEfetuadas] = useState<RowContract[]>([])

  const [campoObrigatorioDataInicial, setcampoObrigatorioDataInicial] =
    useState<boolean>(false)
  const [campoObrigatorioDataFinal, setcampoObrigatorioDataFinal] =
    useState<boolean>(false)
  const [campoObrigatorioOrigem, setcampoObrigatorioOrigem] =
    useState<boolean>(false)
  const [campoObrigatorioDestino, setcampoObrigatorioDestino] =
    useState<boolean>(false)
  const [campoObrigatorioOrdenar, setcampoObrigatorioOrdenar] =
    useState<boolean>(false)
  const [campoObrigatorioTipoPeriodo, setcampoObrigatorioTipoPeriodo] =
    useState<boolean>(false)
  const [campoObrigatorioCliente, setcampoObrigatorioCliente] =
    useState<boolean>(false)
  const [dataInicial, setDataInicial] = useState(new Date())
  const [dataFinal, setDataFinal] = useState(new Date())
  const [tipoperiodo, setTipoPeriodo] = useState("reserva.DataReserva")
  const [ordenar, setOrdenar] = useState("reserva.DataReserva")
  const [origem, setOrigem] = useState("0")
  const [destino, setDestino] = useState("0")
  const [cliente, setCliente] = useState(
    applicationData.acesso !== "funcionario" ? applicationData.funcionario : "0"
  )
  const [reserva, setReserva] = useState("")
  const [passageiro, setPassageiro] = useState("")

  const consultar = async () => {
    const {
      data: { TotalRegistros, Registros }
    } = await api.post("/api/reservas/searchjson", {
      vorigem: origem !== "0" ? origem : 0,
      vdestino: destino !== "0" ? destino : 0,
      vdatainicial: dateFormat(dataInicial),
      vdatafinal: dateFormat(dataFinal),
      vcliente: cliente !== "0" ? cliente : 0,
      vreserva: reserva !== "0" ? reserva : 0,
      vpassageiro: passageiro !== "0" ? passageiro : 0,
      tipoperiodo,
      ordenar,
      limit: paginationControl.limit,
      offset: paginationControl.offset
    })

    setReservasEfetuadas([])
    if (TotalRegistros > 0) {
      const convertingDataToDisplay = (registros: any) =>
        registros.map((registro: any) => {
          return {
            ...registro
          }
        })

      setPaginationControl((current) => ({
        ...current,
        count: TotalRegistros
      }))
      const convertedDataForDisplay = convertingDataToDisplay(Registros)
      setReservasEfetuadas(convertedDataForDisplay)
    }
  }

  return (
    <div>
      <h2>Reimpressão Recibo</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Inicial"
            messageError={
              campoObrigatorioDataInicial ? "Campo obrigatório!" : ""
            }
            value={dataInicial}
            id="data-ini"
            onChange={([date]) => {
              if (String(date) !== "undefined") {
                setDataInicial(date)
                setcampoObrigatorioDataInicial(false)
              } else {
                setcampoObrigatorioDataInicial(true)
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Final"
            messageError={campoObrigatorioDataFinal ? "Campo obrigatório!" : ""}
            value={dataFinal}
            id="data-fim"
            onChange={([date]) => {
              if (String(date) !== "undefined") {
                setDataFinal(date)
                setcampoObrigatorioDataFinal(false)
              } else {
                setcampoObrigatorioDataFinal(true)
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={tipoperiodo}
            messageError={
              campoObrigatorioTipoPeriodo ? "Campo obrigatório!" : ""
            }
            id="periodo"
            label="Tipo de periodo"
            options={[
              { text: "DATA DA RESERVA", value: "reserva.DataReserva" },
              { text: "DATA DO EMBARQUE", value: "Horario" }
            ]}
            onChange={(e) => {
              if (e.target.value !== "") {
                setTipoPeriodo(e.target.value)
                setcampoObrigatorioTipoPeriodo(false)
              }
              if (e.target.value === "") setcampoObrigatorioTipoPeriodo(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Reserva"
            id="reserva"
            type="number"
            value={reserva}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000000 &&
                Number(e.target.value) >= 0
              ) {
                setReserva(e.target.value)
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={origem}
            messageError={campoObrigatorioOrigem ? "Campo obrigatório!" : ""}
            id="origem"
            label="Origem"
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setOrigem(e.target.value)
                setcampoObrigatorioOrigem(false)
              }
              if (e.target.value === "") setcampoObrigatorioOrigem(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={destino}
            messageError={campoObrigatorioDestino ? "Campo obrigatório!" : ""}
            id="destino"
            label="Destino"
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setDestino(e.target.value)
                setcampoObrigatorioDestino(false)
              }
              if (e.target.value === "") setcampoObrigatorioDestino(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={ordenar}
            messageError={campoObrigatorioOrdenar ? "Campo obrigatório!" : ""}
            id="ordenar"
            label="Ordenar por"
            options={[
              { text: "DATA DA RESERVA", value: "reserva.DataReserva" },
              { text: "DATA DO EMBARQUE", value: "Horario" },
              { text: "CLIENTE", value: "parceiro.nome" },
              { text: "RESERVA", value: "reserva.Codigo" }
            ]}
            onChange={(e) => {
              if (e.target.value !== "") {
                setOrdenar(e.target.value)
                setcampoObrigatorioOrdenar(false)
              }
              if (e.target.value === "") setcampoObrigatorioOrdenar(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Passageiro"
            id="passageiro"
            value={passageiro}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setPassageiro("0")
              else {
                setPassageiro(e.target.value)
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <SelectGroup
            value={cliente}
            messageError={campoObrigatorioCliente ? "Campo obrigatório!" : ""}
            id="cliente"
            label="Cliente"
            readOnly={applicationData.acesso !== "funcionario"}
            options={applicationData.clientes.map((cliente: Cliente) => ({
              text: cliente.nome,
              value: cliente.codigo
            }))}
            onChange={(e) => {
              if (
                Number(e.target.value) <= 10000 &&
                Number(e.target.value) >= 0
              ) {
                setCliente(e.target.value)
                setcampoObrigatorioCliente(false)
              }
              if (e.target.value === "") setcampoObrigatorioCliente(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3"></div>

        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Button
            appearance="success"
            onClick={() => {
              consultar()
            }}
          >
            Consultar<IconGoogle>manage_search</IconGoogle>
          </Button>
        </div>
      </div>

      <TableReservas
        data={ReservasEfetuadas}
        onClick={(data) => setReservasEfetuadas(data)}
      ></TableReservas>

      <Pagination
        className="col-12"
        data={paginationControl}
        dispatch={setPaginationControl}
      />
    </div>
  )
}
